var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { attrs: { id: "assignee-setting-container" } },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { staticClass: "p__l--5 p__r--5", attrs: { cols: "5" } },
              [
                _c(
                  "b-form-group",
                  [
                    _c("j-single-select", {
                      attrs: {
                        options: _vm.searchOptions,
                        placeholder: "Type",
                        "value-format": "object"
                      },
                      model: {
                        value: _vm.selectedType,
                        callback: function($$v) {
                          _vm.selectedType = $$v
                        },
                        expression: "selectedType"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              { staticClass: "p__l--5 p__r--5", attrs: { cols: "7" } },
              [
                _c(
                  "b-form-group",
                  [
                    _c("j-input", {
                      attrs: { placeholder: "Search" },
                      model: {
                        value: _vm.searchMember,
                        callback: function($$v) {
                          _vm.searchMember = $$v
                        },
                        expression: "searchMember"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          { staticClass: "assignee-list-vertical" },
          _vm._l(_vm.listMember, function(member, indexMember) {
            return _c(
              "div",
              {
                key: indexMember,
                staticClass: "col-12 m__b--5 assignee-detail"
              },
              [
                _c("div", { staticClass: "checkbox assignee-outer" }, [
                  _c(
                    "label",
                    {
                      staticClass: "row m__b--0 assignee-inner",
                      attrs: { for: member.id }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "assignee-add col-md-2 col-sm-3",
                          staticStyle: {
                            "text-align": "center",
                            "padding-right": "0"
                          }
                        },
                        [
                          _vm.getUserPhoto(member) !== "" &&
                          member.photo_url !== "photo_url"
                            ? _c("img", {
                                staticClass:
                                  "img-responsive card-assignee-photo-modal",
                                attrs: {
                                  title: _vm.getUserEmail(member),
                                  src: _vm.getUserPhoto(member)
                                }
                              })
                            : _c(
                                "span",
                                {
                                  staticClass:
                                    "card-assignee-initial-modal add-card-assignee",
                                  attrs: { title: _vm.getUserEmail(member) }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.getUserInitial(member)) +
                                      "\n              "
                                  )
                                ]
                              )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-md-9 col-sm-7",
                          staticStyle: { "padding-left": "0" }
                        },
                        [
                          _c("div", { staticClass: "f--bold" }, [
                            _vm._v(_vm._s(_vm.getUserName(member)))
                          ]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.getUserTitle(member)))])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-1 col-sm-2" }, [
                        _c(
                          "span",
                          {
                            staticClass: "assignee-remove",
                            on: {
                              click: function($event) {
                                _vm.deleteBoardAssignee(member)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-trash fa-2x" })]
                        )
                      ])
                    ]
                  )
                ]),
                _c("hr")
              ]
            )
          })
        ),
        _vm._v(" "),
        _c("b-row", { staticClass: "assignee-add" }, [
          _c(
            "div",
            { staticClass: " col-12 m__t--10 m__b--10 assignee-detail" },
            [
              _c("label", { staticClass: "row m__b--0 assignee-inner" }, [
                _c("div", { staticClass: "col-3 pr-0" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "card-assignee-initial-modal add-card-assignee",
                      attrs: { id: "assigneeAdd" }
                    },
                    [_vm._v("\n              +\n            ")]
                  )
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "b-popover",
          {
            ref: "popoverAddBoardAssignee",
            attrs: {
              show: _vm.popoverLabelUpdateShow,
              target: "assigneeAdd",
              triggers: "click",
              placement: "auto",
              container: "assignee-setting-container"
            },
            on: {
              "update:show": function($event) {
                _vm.popoverLabelUpdateShow = $event
              }
            }
          },
          [
            _c("h3", [_vm._v("\n        Add Member\n      ")]),
            _vm._v(" "),
            _c(
              "b-form-group",
              { class: { "error-input": _vm.$v.newAssignee.$error } },
              [
                _c("label", { attrs: { for: "assignee" } }, [
                  _vm._v("New Member")
                ]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    id: "assignee",
                    "is-async": true,
                    "load-options": _vm.loadUserOptions,
                    placeholder: "Select",
                    "value-format": "object",
                    label: "name"
                  },
                  model: {
                    value: _vm.newAssignee,
                    callback: function($$v) {
                      _vm.newAssignee = $$v
                    },
                    expression: "newAssignee"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn",
                on: {
                  click: function($event) {
                    _vm.popoverLabelUpdateShow = false
                  }
                }
              },
              [_vm._v("\n        Close\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              { staticClass: "btn blue", on: { click: _vm.addBoardAssignee } },
              [_vm._v("\n        Add\n      ")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17bc05f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17bc05f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/board/assignee/jBoardAssignee.vue
// module id = null
// module chunks = 